module.exports = __webpack_public_path__ + "img/about_tq_app.60841912.png";